document.addEventListener('DOMContentLoaded', () => {
  // Skip entirely on touch/non-pointer devices — no custom cursor needed.
  if (!window.matchMedia('(pointer: fine)').matches) return;

  const cursor = document.getElementById('rh-custom-cursor');
  if (!cursor) return;

  const cursorText = cursor.querySelector('.rh-custom-cursor__text');
  const cursorIcon = cursor.querySelector('.rh-custom-cursor__icon');
  const cursorImage = cursor.querySelector('.rh-custom-cursor__image');

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let cursorX = mouseX;
  let cursorY = mouseY;
  let isHovering = false;
  let rAF = null;

  // Track mouse movement globally — also restarts the render loop if it was idle.
  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    // Restart the render loop if it stopped (cursor had settled)
    if (!rAF) {
      rAF = requestAnimationFrame(render);
    }
  });

  // Smooth follow using requestAnimationFrame.
  // Stops itself once the cursor has settled (< 0.1px delta) to avoid
  // burning CPU at 60fps indefinitely when the mouse isn't moving.
  function render() {
    // Lerp (linear interpolation) for smooth trailing
    cursorX += (mouseX - cursorX) * 0.25;
    cursorY += (mouseY - cursorY) * 0.25;

    if (isHovering) {
      cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0) translate(-50%, -50%) scale(1)`;
    } else {
      cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0) translate(-50%, -50%) scale(0)`;
    }

    // Stop the loop once the cursor has converged on the mouse position.
    // The mousemove handler will restart it when the mouse moves again.
    if (Math.abs(mouseX - cursorX) < 0.1 && Math.abs(mouseY - cursorY) < 0.1) {
      rAF = null;
      return;
    }

    rAF = requestAnimationFrame(render);
  }

  // Function to attach hover listeners to elements
  function attachCursorListeners() {
    const triggerElements = document.querySelectorAll('[data-custom-cursor]');
    
    triggerElements.forEach(el => {
      // Avoid attaching multiple times
      if (el.dataset.cursorAttached) return;
      el.dataset.cursorAttached = "true";

      el.addEventListener('mouseenter', () => {
        isHovering = true;
        cursor.classList.add('is-active');

        const type = el.getAttribute('data-cursor-type') || 'text';
        cursor.setAttribute('data-type', type);

        const bgColor = el.getAttribute('data-cursor-bg');
        const textColor = el.getAttribute('data-cursor-color');
        const cursorInner = cursor.querySelector('.rh-custom-cursor__inner');
        
        if (bgColor) cursorInner.style.background = bgColor;
        if (textColor) cursorInner.style.color = textColor;

        if (type === 'text') {
          cursorText.textContent = el.getAttribute('data-cursor-text') || 'View';
        } else if (type === 'icon') {
          cursorIcon.innerHTML = el.getAttribute('data-cursor-icon') || '';
        } else if (type === 'image') {
          const imgSrc = el.getAttribute('data-cursor-image');
          if (imgSrc) cursorImage.src = imgSrc;
        }
      });

      el.addEventListener('mouseleave', () => {
        isHovering = false;
        cursor.classList.remove('is-active');
      });
    });
  }

  // Initial attachment
  attachCursorListeners();

  // Re-attach if DOM changes (useful for dynamically loaded sections).
  // Scoped to #MainContent rather than document.body — data-custom-cursor elements
  // are only rendered inside section blocks (e.g. blocks/image.liquid), never in
  // header/footer chrome. This avoids re-firing on unrelated DOM mutations
  // (e.g. parity-animations.js wrapping clip-reveal elements).
  const observeTarget = document.getElementById('MainContent') || document.body;
  const observer = new MutationObserver((mutations) => {
    let shouldReattach = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldReattach = true;
        break;
      }
    }
    if (shouldReattach) {
      attachCursorListeners();
    }
  });

  observer.observe(observeTarget, { childList: true, subtree: true });
});
